import React from 'react';
import { Box } from '@goodrx/matisse';
import { Service } from 'app/types/Service';
import { MarketingFooter } from 'app/components/footers/MarketingFooter';
import { CanonicalLink } from 'app/components/links/CanonicalLink';
import { HeaderTheme } from '../MarketingHeader/HeaderTheme';
import { MarketingHeader } from '../MarketingHeader';

interface MarketingLayoutProps {
  headerTheme?: HeaderTheme;
  services?: Service[];
  canonicalLink: string | null;
}

export const MarketingLayout: React.FC<MarketingLayoutProps> = ({ children, headerTheme, services, canonicalLink }) => (
  <Box>
    {canonicalLink && <CanonicalLink path={canonicalLink} />}
    <MarketingHeader headerTheme={headerTheme} />
    <Box flex={1}>{children}</Box>
    <MarketingFooter services={services} />
  </Box>
);
